import React from 'react'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import EMobilityChargingCardsTable from './EMobilityChargingCardsTable'
import { ApiTableSkeleton } from '@e3dc-react/shell/Elements/Skeletons'
import { useEMobilityChargingCards } from './api/e-mobility-charging-cards.api'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'

const useStyles = makeStyles()(theme => ({
  errorMessage: {
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
}))

interface EMobilityChargingCardsProps {
  storageId: string
}

const EMobilityChargingCards = ({ storageId }: EMobilityChargingCardsProps): React.ReactElement => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  const { data, isLoading, isError } = useEMobilityChargingCards(storageId)

  if (isLoading || !data) {
    return <ApiTableSkeleton withFilter={false} />
  }

  if (isError) {
    return (
      <Typography variant={'caption'} color={'error'} className={classes.errorMessage}>
        {t('emobility.chargingCards.errorMessage')}
      </Typography>
    )
  }

  return (
    <>
      <BannerQueue location={BannerLocations.Emobility} />
      <EMobilityChargingCardsTable data={data} />
    </>
  )
}

export default EMobilityChargingCards
